import { onMount, Show } from "solid-js";
import { Title } from "@solidjs/meta";
import { HttpStatusCode } from "@solidjs/start";

import Trans from "@repo/localization/jsx.macro";
import AppRouter from "@repo/utils-solid/AppRouter";

import { track } from "~/analytics/client";

export default function NotFound() {
  return (
    <Show
      when={AppRouter.depth() === 0}
      fallback={(() => {
        onMount(() => {
          // May encouter 404 when attempting to go to valid route outside app,
          // check with full page load.
          // Reloading immediately reloads previous route, wait until location is updated
          requestAnimationFrame(() => {
            window.location.reload();
          });
        });

        return null;
      })()}
    >
      {(() => {
        onMount(() => {
          track.notFoundPage("impression");
        });

        return (
          <main>
            <Title>
              <Trans>Not Found</Trans>
            </Title>
            <HttpStatusCode code={404} />
            <h1>
              <Trans>Page Not Found</Trans>
            </h1>
          </main>
        );
      })()}
    </Show>
  );
}
